import { render, staticRenderFns } from "./testimonialBlock.vue?vue&type=template&id=515fa9bf&"
import script from "./testimonialBlock.vue?vue&type=script&lang=js&"
export * from "./testimonialBlock.vue?vue&type=script&lang=js&"
import style0 from "./testimonialBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports